import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appOpenLinksInNewTab]'
})
export class OpenLinksInNewTabDirective {

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const link = target.closest('a'); // finds nearest <a> element if clicked inside

    if (link && link.getAttribute('href')) {
      const url = link.getAttribute('href');
      if (url && !url.startsWith('#') && !url.startsWith('javascript:')) {
        event.preventDefault(); // prevent Angular router handling it
        window.open(url, '_blank', 'noopener,noreferrer');
      }
    }
  }
}